import { render } from "./Fields.vue?vue&type=template&id=57b62805&scoped=true"
import script from "./Fields.vue?vue&type=script&lang=js"
export * from "./Fields.vue?vue&type=script&lang=js"

import "./Fields.vue?vue&type=style&index=0&id=57b62805&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-57b62805"

export default script